import { render, staticRenderFns } from "./RegulatorAdd.vue?vue&type=template&id=0449b5b2&"
import script from "./RegulatorAdd.vue?vue&type=script&lang=js&"
export * from "./RegulatorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports